"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.identity = identity;
function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/util/identity.js
// module id = 222
// module chunks = 0